import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as api from '../../api/api'
import { Grid, GridCell } from 'rmwc/Grid';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import PaginationComponent from '../PaginationComponent';

class AdminViewCoupons extends Component{

  constructor(props) {
    super(props)
    this.state = {
      status: '',
      errorMsg: '',
      limit: 100,
      totalCount: '',
      data: {
        couponDetails:[]
      }
    }
    
    
  }
  componentDidMount() {
    
    let data = Object.assign({}, this.state.data)
    api.adminViewCoupons(this.props.user.accessToken, 1, this.state.limit).then((result) => {
			const { status, errors} = result
			if (status === 'success') {
			data.couponDetails = result.data
			this.setState({data:data, totalCount: result.count})
			}
			else {
			this.setState({ errorMsg: 'Error in Fetching Detail' })  
			}
		})
			.catch((err) => {
			this.setState({ errorMsg: 'Error in Fetching Details' })
		})
  }

  fetchCouponDetails = (pageNo) => {
  	let data = Object.assign({}, this.state.data)
    api.adminViewCoupons(this.props.user.accessToken, pageNo, this.state.limit)
    .then((result) => {
      if(result.status === 'success'){
      	data.couponDetails = result.data
      this.setState({data: data,totalCount: result.count})
      }
    })
  }

  goBack = () => {
    this.props.history.push('/portal/app/admin/coupons')
  }

  render(){
    let userListCompnent
    let paginationKey = this.state.totalCount
    
    if(this.state.data.couponDetails.length >0){
      userListCompnent = 
        ( <tbody>
            {this.state.data.couponDetails.map(function(coupon) {
            	return(
              <tr>
                <td>{coupon.name}</td>
                <td>{coupon.test_track_name}</td>
                <td>{coupon.total_count}</td>
                <td>{coupon.remaining_count}</td>
                <td>{coupon.created_at.split('T')[0]}</td>
                <td>{coupon.updated_at.split('T')[0]}</td>  
              </tr>)
            })}
          </tbody>  
        )

     }

    return (
        <div>
          <Grid>
            <GridCell span="10"><Typography use="headline6">Coupons Details</Typography></GridCell>
            <GridCell span="2"><Button raised onClick={this.goBack}>Go Back</Button></GridCell>
          </Grid>
          <Grid>
            <GridCell span="12">
              <div>
                <table className="admin-table">
                  <th>Coupon Name</th>
                  <th>Test Track</th>
                  <th>Total Count</th>
                  <th>Remaining Count</th>
                  <th>Created At</th>
                  <th>Last Updated</th>
                  {userListCompnent}
                </table>
              </div>
              <div key={paginationKey}>
  	          	<PaginationComponent totalItems = {this.state.totalCount}
  	            itemsPerPage = {this.state.limit} 
  	            onHandleItemsFetch = {this.fetchCouponDetails} />
          	  </div>
            </GridCell>
            </Grid>
        </div>
      )
  }

}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminViewCoupons);


// WEBPACK FOOTER //
// ./src/views/admin/AdminViewCoupons.jsx